
import React from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import Footer from "@/components/home/Footer";
import FeedbackForm from "@/components/common/FeedbackForm";

const Feedback = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Feedback - Hivetivity</title>
        <meta name="description" content="Share your feedback to help us improve Hivetivity." />
      </Helmet>
      
      <TopNavbar />
      
      <div className="pt-16 pb-16">
        <div className="container mx-auto px-4 py-8 max-w-3xl">
          <FeedbackForm />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Feedback;
